<div class="bubble-chart-container"  #chartContainer>
    <mat-spinner *ngIf="spinFlag" style="margin:0 auto; margin-top: 10%;"></mat-spinner>
  <div class="bubble-chart-tooltip">
  </div>
</div>